module.exports = "<div id=\"googleMap\" class=\"img-responsive\" style=\"width:1170px;height:400px;\"></div>"